import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 14.601 17.923"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7.29 9.828h-.032A7.321 7.321 0 0 0 0 17.193a.73.73 0 0 0 .73.73h13.137a.73.73 0 0 0 .73-.73 7.379 7.379 0 0 0-2.161-5.2A7.217 7.217 0 0 0 7.29 9.828ZM7.458 8.245a4.123 4.123 0 0 0-.02-8.246h-.019a4.123 4.123 0 1 0 .019 8.246Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }